import { render, staticRenderFns } from "./FndRoleDetail.vue?vue&type=template&id=ae34ebcc&"
import script from "./FndRoleDetail.vue?vue&type=script&lang=js&"
export * from "./FndRoleDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports